import React from 'react';
import { FolderOutlined } from '@ant-design/icons';
import { getItem } from '../../util';

export const FE10Items = getItem('FE10', 'FE10', <FolderOutlined />, [
  getItem('FE10 Base Stats-Halberdier', 'FE10/BaseStatsHalberdier'),
  getItem('FE10 Base Stats-Sentinal', 'FE10/BaseStatsSentinal'),
  getItem('FE10 Base Stats-Soldier', 'FE10/BaseStatsSoldier'),
  getItem('FE10 Class Editor', 'FE10/ClassEditor'),
  getItem('FE10 Class Editor-Arch Sage', 'FE10/ClassEditorArchSage'),
  getItem('FE10 Class Editor-Archer', 'FE10/ClassEditorArcher'),
  getItem('FE10 Class Editor-Armors', 'FE10/ClassEditorArmors'),
  getItem('FE10 Class Editor-Ashura(Aura)', 'FE10/ClassEditorAshuraAura'),
  getItem('FE10 Class Editor-Assassin', 'FE10/ClassEditorAssassin'),
  getItem('FE10 Class Editor-Bandit', 'FE10/ClassEditorBandit'),
  getItem('FE10 Class Editor-Cleric', 'FE10/ClassEditorCleric'),
  getItem('FE10 Class Editor-Dark Sage, Sages (SP)', 'FE10/ClassEditorDarkSageSagesSP'),
  getItem('FE10 Class Editor-Dracoknights', 'FE10/ClassEditorDracoknights'),
  getItem('FE10 Class Editor-Dragon King', 'FE10/ClassEditorDragonKing'),
  getItem('FE10 Class Editor-Dragon Prince', 'FE10/ClassEditorDragonPrince'),
  getItem('FE10 Class Editor-Dragonlord', 'FE10/ClassEditorDragonlord'),
  getItem('FE10 Class Editor-Druid', 'FE10/ClassEditorDruid'),
  getItem('FE10 Class Editor-Falcon Knights', 'FE10/ClassEditorFalconKnights'),
  getItem('FE10 Class Editor-Fighter', 'FE10/ClassEditorFighter'),
  getItem('FE10 Class Editor-Generals', 'FE10/ClassEditorGenerals'),
  getItem('FE10 Class Editor-Giffca (Transformed)', 'FE10/ClassEditorGiffcaTransformed'),
  getItem('FE10 Class Editor-Giffca (Untransformed)', 'FE10/ClassEditorGiffcaUntransformed'),
  getItem('FE10 Class Editor-Gold Knights, Silver Knights', 'FE10/ClassEditorGoldKnightsSilverKnights'),
  getItem('FE10 Class Editor-Hawk (Transformed)', 'FE10/ClassEditorHawkTransformed'),
  getItem('FE10 Class Editor-Hawk (Untransformed)', 'FE10/ClassEditorHawkUntransformed'),
  getItem('FE10 Class Editor-Hawk King', 'FE10/ClassEditorHawkKing'),
  getItem('FE10 Class Editor-Hero', 'FE10/ClassEditorHero'),
  getItem('FE10 Class Editor-Heron(Leanne)', 'FE10/ClassEditorHeronLeanne'),
  getItem('FE10 Class Editor-Heron(Rafiel)', 'FE10/ClassEditorHeronRafiel'),
  getItem('FE10 Class Editor-Heron(Reyson)', 'FE10/ClassEditorHeronReyson'),
  getItem('FE10 Class Editor-Knight', 'FE10/ClassEditorKnight'),
  getItem('FE10 Class Editor-Light Mage, Sages', 'FE10/ClassEditorLightMageSages'),
  getItem('FE10 Class Editor-Light Sage', 'FE10/ClassEditorLightSage'),
  getItem('FE10 Class Editor-Lion King (Transformed)', 'FE10/ClassEditorLionKingTransformed'),
  getItem('FE10 Class Editor-Lion King (Untransformed)', 'FE10/ClassEditorLionKingUntransformed'),
  getItem('FE10 Class Editor-Mages', 'FE10/ClassEditorMages'),
  getItem('FE10 Class Editor-Marksman', 'FE10/ClassEditorMarksman'),
  getItem('FE10 Class Editor-Marshalls, Black Knight', 'FE10/ClassEditorMarshallsBlackKnight'),
  getItem('FE10 Class Editor-Myrmidon', 'FE10/ClassEditorMyrmidon'),
  getItem('FE10 Class Editor-Paladins', 'FE10/ClassEditorPaladins'),
  getItem('FE10 Class Editor-Pegusus Knights', 'FE10/ClassEditorPegususKnights'),
  getItem('FE10 Class Editor-Pilgrim, Vendor, Citizen, Horse', 'FE10/ClassEditorPilgrimVendorCitizenHorse'),
  getItem('FE10 Class Editor-Priest', 'FE10/ClassEditorPriest'),
  getItem('FE10 Class Editor-Raven King', 'FE10/ClassEditorRavenKing'),
  getItem('FE10 Class Editor-Raven(F)', 'FE10/ClassEditorRavenF'),
  getItem('FE10 Class Editor-Raven(M)', 'FE10/ClassEditorRavenM'),
  getItem('FE10 Class Editor-Reaver', 'FE10/ClassEditorReaver'),
  getItem('FE10 Class Editor-Red Dragon(F)', 'FE10/ClassEditorRedDragonF'),
  getItem('FE10 Class Editor-Red Dragon(M)', 'FE10/ClassEditorRedDragonM'),
  getItem('FE10 Class Editor-Rogue(F)', 'FE10/ClassEditorRogueF'),
  getItem('FE10 Class Editor-Rogue(M)', 'FE10/ClassEditorRogueM'),
  getItem('FE10 Class Editor-Saint', 'FE10/ClassEditorSaint'),
  getItem('FE10 Class Editor-Seraph Knight, Queen', 'FE10/ClassEditorSeraphKnightQueen'),
  getItem('FE10 Class Editor-Skrimir-Transformed', 'FE10/ClassEditorSkrimirTransformed'),
  getItem('FE10 Class Editor-Skrimir(Untransformed)', 'FE10/ClassEditorSkrimirUntransformed'),
  getItem('FE10 Class Editor-Sniper', 'FE10/ClassEditorSniper'),
  getItem('FE10 Class Editor-Spirit', 'FE10/ClassEditorSpirit'),
  getItem('FE10 Class Editor-Summoner', 'FE10/ClassEditorSummoner'),
  getItem('FE10 Class Editor-Swordmaster', 'FE10/ClassEditorSwordmaster'),
  getItem('FE10 Class Editor-Thief', 'FE10/ClassEditorThief'),
  getItem('FE10 Class Editor-Tiger(Transformed)', 'FE10/ClassEditorTigerTransformed'),
  getItem('FE10 Class Editor-Tiger(Untransformed)', 'FE10/ClassEditorTigerUntransformed'),
  getItem('FE10 Class Editor-Trueblade', 'FE10/ClassEditorTrueblade'),
  getItem('FE10 Class Editor-Unknown', 'FE10/ClassEditorUnknown'),
  getItem('FE10 Class Editor-Valkyrie', 'FE10/ClassEditorValkyrie'),
  getItem('FE10 Class Editor-Vanguard', 'FE10/ClassEditorVanguard'),
  getItem('FE10 Class Editor-Warrior', 'FE10/ClassEditorWarrior'),
  getItem('FE10 Class Editor-Warrior (SP)', 'FE10/ClassEditorWarriorSP'),
  getItem('FE10 Class Editor-Whisper', 'FE10/ClassEditorWhisper'),
  getItem('FE10 Class Editor-White Dragon', 'FE10/ClassEditorWhiteDragon'),
  getItem('FE10 Class Editor-Wolf Queen', 'FE10/ClassEditorWolfQueen'),
  getItem('FE10 Growth Rates-Astrid, Soren', 'FE10/GrowthRatesAstridSoren'),
  getItem('FE10 Growth Rates-Black Knight 1 & 2, Shinon, Giffca, Geoffrey', 'FE10/GrowthRatesBlackKnight12ShinonGiffcaGeoffrey'),
  getItem('FE10 Growth Rates-Danved & Ulki', 'FE10/GrowthRatesDanvedUlki'),
  getItem('FE10 Growth Rates-Edward & Elincia', 'FE10/GrowthRatesEdwardElincia'),
  getItem('FE10 Growth Rates-Ena & Ilyana', 'FE10/GrowthRatesEnaIlyana'),
  getItem('FE10 Growth Rates-Fiona, Heather', 'FE10/GrowthRatesFionaHeather'),
  getItem('FE10 Growth Rates-Gatrie,Calill & Kyza', 'FE10/GrowthRatesGatrieCalillKyza'),
  getItem('FE10 Growth Rates-Haar, Vika', 'FE10/GrowthRatesHaarVika'),
  getItem('FE10 Growth Rates-Hetzel, Pelleas, Boyd, Marcia', 'FE10/GrowthRatesHetzelPelleasBoydMarcia'),
  getItem('FE10 Growth Rates-Ike and Izuka', 'FE10/GrowthRatesIkeandIzuka'),
  getItem('FE10 Growth Rates-Jill, Skrimir', 'FE10/GrowthRatesJillSkrimir'),
  getItem('FE10 Growth Rates-Lehran', 'FE10/GrowthRatesLehran'),
  getItem('FE10 Growth rates-Leonardo, Lethe', 'FE10/GrowthratesLeonardoLethe'),
  getItem('FE10 Growth rates-Levail', 'FE10/GrowthratesLevail'),
  getItem('FE10 Growth Rates-Lyre, Reyson, Lekain, Lucia', 'FE10/GrowthRatesLyreReysonLekainLucia'),
  getItem('FE10 Growth Rates-Makalov, Micaiah', 'FE10/GrowthRatesMakalovMicaiah'),
  getItem('FE10 Growth Rates-Meg, Mordecai, Janaff, Bastian, Rolf', 'FE10/GrowthRatesMegMordecaiJanaffBastianRolf'),
  getItem('FE10 Growth rates-Mia, Kurth, Aimee', 'FE10/GrowthratesMiaKurthAimee'),
  getItem('FE10 Growth Rates-Mist, Muarim', 'FE10/GrowthRatesMistMuarim'),
  getItem('FE10 Growth Rates-Nealuchi, Nailah, Naesala', 'FE10/GrowthRatesNealuchiNailahNaesala'),
  getItem('FE10 Growth Rates-Nephenee, Nolan', 'FE10/GrowthRatesNepheneeNolan'),
  getItem('FE10 Growth Rates-Oscar & Oliver', 'FE10/GrowthRatesOscarOliver'),
  getItem('FE10 Growth Rates-Ranulf, Rafiel, Leanne', 'FE10/GrowthRatesRanulfRafielLeanne'),
  getItem('FE10 Growth rates-Renning, Laura', 'FE10/GrowthratesRenningLaura'),
  getItem('FE10 Growth Rates-Rhys,Kurthnaga, Kieran & Gareth', 'FE10/GrowthRatesRhysKurthnagaKieranGareth'),
  getItem('FE10 Growth Rates-Sephiran, Zelgius', 'FE10/GrowthRatesSephiranZelgius'),
  getItem('FE10 Growth Rates-Sothe, Sanaki & Sigrun', 'FE10/GrowthRatesSotheSanakiSigrun'),
  getItem('FE10 Growth Rates-Stefan,Tauroneo,Tanith,Brom,Zihark,Titania', 'FE10/GrowthRatesStefanTauroneoTanithBromZiharkTitania'),
  getItem('FE10 Growth Rates-Tibarn, Dheginsea', 'FE10/GrowthRatesTibarnDheginsea'),
  getItem('FE10 Growth Rates-Tormod, Nasir', 'FE10/GrowthRatesTormodNasir'),
  getItem('FE10 Growth Rates-Volke, Aran', 'FE10/GrowthRatesVolkeAran'),
  getItem('FE10 Growth Rates-Volug & Caineghis', 'FE10/GrowthRatesVolugCaineghis'),
]);

export default FE10Items;
